import { TaxTypeGetRequest } from '@dave/types';
import { createActionGroup, props } from '@ngrx/store';
import { TaxTypeEntity } from '../../entities/tax-type.entity';

export const TaxTypeActions = createActionGroup({
    source: 'TaxType',
    events: {
        'Load Success': props<{ Payload: TaxTypeEntity[] }>(),
        'Load Request': props<{ Payload?: TaxTypeGetRequest }>(),
        'Load Failure': props<{ Errors: any; ToasterMessage?: string }>(),
    },
});
